export default "__VITE_ASSET__BtmxVQaf__"